import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessagesModule } from 'primeng/messages';
import { SelectButtonModule } from 'primeng/selectbutton';

import { FormFieldHelpComponent } from '../../form/form-field-help/form-field-help.component';
import { AccordionWizardModule } from '../../generic/accordion-wizard/accordion-wizard.module';
import { SequenceModule } from '../../generic/sequence/sequence.module';
import { CallListAutocompleteModule } from '../call-list/select/call-list-autocomplete/call-list-autocomplete.module';
import { CommunicationWidgetModule } from '../communication-widget/communication-widget.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { RruleEditorComponent } from '../rrule-editor/rrule-editor.component';

import { ServiceCommandEditorAutoAcceptCallComponent } from './service-command-editor-auto-accept-call/service-command-editor-auto-accept-call.component';
import { ServiceCommandEditorContainerComponent } from './service-command-editor-container/service-command-editor-container.component';
import { ServiceCommandEditorCreateAsyncServiceRequestComponent } from './service-command-editor-create-async-service-request/service-command-editor-create-async-service-request.component';
import { ServiceCommandEditorDialCallListComponent } from './service-command-editor-dial-call-list/service-command-editor-dial-call-list.component';
import { ServiceCommandEditorEnforceServiceLimitComponent } from './service-command-editor-enforce-service-limit/service-command-editor-enforce-service-limit.component';
import { ServiceCommandEditorExecIvrComponent } from './service-command-editor-exec-ivr/service-command-editor-exec-ivr.component';
import { ServiceCommandEditorFlagServiceRequestComponent } from './service-command-editor-flag-service-request/service-command-editor-flag-service-request.component';
import { ServiceCommandEditorForwardComponent } from './service-command-editor-forward/service-command-editor-forward.component';
import { ServiceCommandEditorPlayOrSayComponent } from './service-command-editor-play-or-say/service-command-editor-play-or-say.component';
import { ServiceCommandEditorTakeVoicemailComponent } from './service-command-editor-take-voicemail/service-command-editor-take-voicemail.component';
import { ServiceCommandNameSelectComponent } from './service-command-name-select/service-command-name-select.component';
import { ServiceLimitEditorComponent } from './service-limit-editor/service-limit-editor.component';
import { ServiceOperationEditorComponent } from './service-operation-editor/service-operation-editor.component';
import { VrcAudioSelectComponent } from './vrc-audio-select/vrc-audio-select.component';

@NgModule({
  declarations: [
    ServiceCommandEditorContainerComponent,
    ServiceCommandEditorCreateAsyncServiceRequestComponent,
    ServiceCommandEditorDialCallListComponent,
    ServiceCommandEditorEnforceServiceLimitComponent,
    ServiceCommandEditorFlagServiceRequestComponent,
    ServiceCommandEditorPlayOrSayComponent,
    ServiceCommandNameSelectComponent,
    ServiceLimitEditorComponent,
    ServiceOperationEditorComponent,
    VrcAudioSelectComponent,
  ],
  imports: [
    AccordionWizardModule,
    AutoCompleteModule,
    CallListAutocompleteModule,
    CommonModule,
    CommunicationWidgetModule,
    DropdownModule,
    FormFieldHelpComponent,
    InputNumberModule,
    InputSwitchModule,
    MatIconModule,
    MessagesModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    RruleEditorComponent,
    SelectButtonModule,
    SequenceModule,
    ServiceCommandEditorAutoAcceptCallComponent,
    ServiceCommandEditorExecIvrComponent,
    ServiceCommandEditorForwardComponent,
    ServiceCommandEditorTakeVoicemailComponent,
    TranslocoModule,
  ],
  exports: [ServiceOperationEditorComponent, VrcAudioSelectComponent],
})
export class ServiceOperationEditorModule {}
